$( document ).ready(function() {
    console.log( "ready Vi !" );
    
    // =================================================
    // Playr Init
    // =================================================
    let getHomeBannerVideo = $('#vi_emeslider_vidplyr');
    if(getHomeBannerVideo.length){
        const ghHomePlyr = new Plyr( getHomeBannerVideo, {
            controls : false,
            autoplay : true,
            playsinline : true,
            muted : true, 
            hideControls : true,
            // resetOnEnd : true,
            // loop : true, 
        });
    }
    
    // =================================================
    // Home Banner Slider
    // =================================================
    
    let getHomeBannerSlider = $("#vi_emeslider_main_v2.video__disabled");
    if( getHomeBannerSlider.length ){
        let argsSliderESV2 = { 
            items: 1,
            loop: false, 
            // margin: 0,
            autoplay: true,
            dots: true,
            autoplayHoverPause: true,
            // dragEndSpeed: 1500,
            navSpeed: 1500,
            smartSpeed: 3000,
            slideSpeed: 1200,
            nav : false,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            // lazyLoad: true,
            responsive: {
                768: {
                    items: 1,
                },
                1200: {
                    items: 1,
                }
            }
        }
        getHomeBannerSlider.owlCarousel(argsSliderESV2);
    }
    
    
    // ===================================
    // Hamburg Open / Close ::> Animated
    // ===================================
    let hamburgIcon = $(".viv__main_header_rigt-hamburg #navburg");
    if(hamburgIcon.length){
        hamburgIcon.click(function(eHambrg){

            // Hide others
            $(".viv__main_header_rigt-bookbtn-selectr").removeClass("show");
            
            $(this).toggleClass("opened");
        });
    }
    
    // ===================================
    // Hamburg Open / Close ::> Offcanvas
    // ===================================
    let offCanvas = $(".main_header_offcanvas");
    if(offCanvas.length){
        hamburgIcon.click(function(eOfC){
            offCanvas.toggleClass("opened");
        });
    }
    
    // ===================================
    // Offcanvas Open / Close ::> Submenu
    // ===================================
    let offCanvasSubmenuParent = $("nav ul li.menu-item-has-children");
    if(offCanvasSubmenuParent.length){
        offCanvasSubmenuParent.find("a").append("<span class='ddown'><span>");

        offCanvasSubmenuParent.find(".ddown").click(function(eDDown){
            eDDown.preventDefault();
            eDDown.stopPropagation();

            // Add class to self
            // offCanvasSubmenuParent.find("span.ddown").removeClass("opened");
            $(this).toggleClass("opened");

            // open the submenu
            $(this).parents(".menu-item-has-children").children("ul.sub-menu").toggleClass("opened");
        });
        offCanvasSubmenuParent.click(function(eSubMenuItem){

            // Hide others
            $(".viv__main_header_rigt-bookbtn-selectr").removeClass("show");
            $(".viv__main_header_rigt-hamburg #navburg").removeClass("opened show");
            // $(".viv__overflowd_menus").removeClass("opened show");
            
            // Add class to self
            $(this).toggleClass("opened");
            // open the submenu
            // $(this).children("ul.sub-menu").toggleClass("opened");
            
            // collapse previously opened submenu items, parent li items
            offCanvasSubmenuParent.not(this).removeClass("opened");
            offCanvasSubmenuParent.not(this).find("ul.sub-menu").removeClass("opened");
            
        });
    }


    // ==========================================================
    // Toggle submenu on first click, redirect on second click
    // ==========================================================
    
    // Hide submenus initially
    $('#menu-desktop-horizontal-menu .sub-menu').hide();

    // Initialize flag to track if the submenu was clicked
    var submenuClicked = false;

    // Toggle submenu on first click, redirect on second click
    $('#menu-desktop-horizontal-menu .menu-item-has-children').click(function(e) {
        // If the submenu was already clicked, redirect immediately
        if (submenuClicked) {
            window.location = $(this).children('a').attr('href');
            return;
        }

        // Prevent redirection on the first click
        e.preventDefault();

        var $submenu = $(this).children('.sub-menu');

        if (!$submenu.is(':visible')) {
            // Submenu is hidden, show it
            $submenu.slideToggle();
        }
        else {
            // Submenu is visible, reset the flag
            submenuClicked = false;
        }

        // Toggle the flag
        submenuClicked = true;
    });

    // Hide submenu and reset flag when clicking outside the menu
    $(document).click(function(e) {
        var $target = $(e.target);
        if (!$target.closest('#menu-desktop-horizontal-menu .menu-item-has-children').length) {
            $('#menu-desktop-horizontal-menu .sub-menu').slideUp();
            submenuClicked = false;
        }
    });
    

    // =================================
    // Book Button menu 
    // =================================
    let book_now_btn = $(".viv__main_header_rigt-bookbtn a.viv__main_header_rigt-bookbtn-main");
    
    let book_now_btn_menu = $(".viv__main_header_rigt-bookbtn-selectr");
    

    book_now_btn.click(function(){

        // Hide others
        $(".viv__main_header_rigt-hamburg #navburg").removeClass("opened show");
        $(".viv__overflowd_menus").removeClass("opened show");


        $(".viv__main_header_midd ul li.menu-item-has-children").removeClass("opened");
        $(".viv__main_header_midd ul li.menu-item-has-children a").removeClass("show").attr("aria-expanded", "false");
        $(".viv__main_header_midd ul li.menu-item-has-children ul.sub-menu").removeClass("opened show");

        // Show this
        $(this).parent().find(".viv__main_header_rigt-bookbtn-selectr").toggleClass("show");



        // book button highlight when book menu is opened
        if(book_now_btn_menu.hasClass("show")){
            book_now_btn.toggleClass("opened_menu");
            // book_now_btn.find("span").html("<strong>X</strong>");
        }
        // else{
        //     book_now_btn.find("span").html("<strong>Book</strong> Now");
        // }
    });
    // sub menus
    book_now_btn.parent().find(".viv__main_header_rigt-bookbtn-selectr ul > li.menu-item-has-children > a").click(function(){

        $(this).parent().find("ul.sub-menu ").toggleClass("show");
        $(this).parent().toggleClass("opened");
    });

    


    // =================================
    // AOS Init
    // =================================
    
    AOS.init();
    
    
    // =================================
    // Fancybox Init
    // =================================
    
    Fancybox.bind("[data-fancybox]", { 
        Carousel: {
            infinite: false,
            transition: "slide",
        },
        Thumbs: false,
        showClass: "f-fadeIn",
        groupAll : false,
        // groupAttr: false,
     });
    
    
    // =================================
    // Homepage Img Galry Slider
    // =================================    
    let getHomeImgGalry = $("#hmpg__img_galry_cont-slider-main");
    if(getHomeImgGalry.length){
        let argsHmImgGalry = {
            items: 1,
            loop: true, 
            margin: 0,
            autoplay: true,
            dots: false,
            // autoplayHoverPause: true,
            //animateOut: "fadeOut", 
            // dragEndSpeed: 1500,
            // navSpeed: 3000,
            speed:3000,
            slideTransition: 'linear',
            autoplaySpeed: 12000,
            smartSpeed: 12000,
            nav : false,
            // animateIn: 'fadeIn',
            // animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            // lazyLoad: true,
            autoWidth : true,
            responsive: {
                768: {
                    margin: 2,
                    items: 2,
                },
                1600: {
                    margin: 0,
                    items: 3,
                }
            }
        }
        getHomeImgGalry.owlCarousel(argsHmImgGalry);
        
        
    }
    
    
    // =================================
    // Homepage Locations Slider
    // =================================    
    let getHomeLocationSlidr = $(".hmpg__locations_cont-slider-main");
    
    if( getHomeLocationSlidr.length ){
        
        getHomeLocationSlidr.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            
            if (!e.namespace) {
                return;
            }
            
            let expCounter, curItemCounter, totalItemCounter;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+("0"+e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounter = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounter = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                expCounter = curItemCounter + " | " + totalItemCounter
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounter = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounter = "0"+ (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ "0" +(e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".explore-counter").html( expCounter );
            
        })
        
        .owlCarousel({
            items: 1,
            loop: false, 
            margin: 20,
            autoplay: true,
            dots: false,
            autoplayHoverPause: true,
            //animateOut: "fadeOut", 
            // dragEndSpeed: 1500,
            navSpeed: 1500,
            // smartSpeed: 500,
            nav : false,
            // animateIn: 'fadeIn',
            // animateOut: 'fadeOut',
            navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#vivi_nav_left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#vivi_nav_right"></use></svg>'],
            lazyLoad: true,
            responsive: {
                768: {
                    items: 2,
                    margin: 25,
                },
                1600: {
                    items: 3,
                }
            }
        });
        
        
        // custom nav buttons with the counter
        $('.hmpg__locations_cont-slider-main-item-countnav-rght a').click(function(){
            // console.log("next");
            getHomeLocationSlidr.trigger('next.owl.carousel');
        });
        
        $('.hmpg__locations_cont-slider-main-item-countnav-left a').click(function(){
            // console.log("prev");
            getHomeLocationSlidr.trigger('prev.owl.carousel');
        });
        
    }    
    
    
        
    // =================================
    // Homepage Promos & Events Galry Slider
    // =================================    
    let getHomePromosEvents = $(".hmpg__promos_events-cont-slider");
    if(getHomePromosEvents.length){

        getHomePromosEvents.on("initialized.owl.carousel changed.owl.carousel", function(e) {
            
            if (!e.namespace) {
                return;
            }
            
            let expCounter, curItemCounter, totalItemCounter;
            
            // -- Add trailing zeroes to both CurrentItemCount and TotalCount when the total count is less than 10
            if( e.item.count < 9 ){
                expCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+("0"+e.item.count)+"</span>"
            }
            // -- When total count is more than 10
            else{
                // -- if CurrentItemCount is less than 10, add leading zero
                if(e.item.index < 9 ){
                    curItemCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1);
                    // totalItemCounter = "<span>"+ "0" + (e.item.count) +"</span>";
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                else{
                    curItemCounter = e.relatedTarget.relative(e.item.index) + 1; 
                    totalItemCounter = "<span>"+ e.item.count +"</span>"
                }
                expCounter = curItemCounter + " | " + totalItemCounter
            }
            
            // -- When TotalCount is exactly 10, 
            if( e.item.count === 10 ){
                
                if(e.item.index === 9 ){
                    expCounter = e.relatedTarget.relative(e.item.index) + 1 + " | " + "<span>"+ e.item.count +"</span>"
                }
                else{
                    expCounter = "0"+(e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ e.item.count +"</span>"
                }
            }
            
            // -- If TotalCount is exactly 9,
            if( e.item.count === 9 ){
                expCounter = "0"+ (e.relatedTarget.relative(e.item.index) + 1) + " | " + "<span>"+ "0" +(e.item.count) +"</span>"
            }
            
            // Add counter to the HTML
            $(".promo__events-explore-counter").html( expCounter );
            
        })
        .owlCarousel({
            items: 1,
            loop: false, 
            margin: 0,
            autoplay: false,
            dots: false,
            // autoplayHoverPause: true,
            //animateOut: "fadeOut", 
            // dragEndSpeed: 1500,
            navSpeed: 1500,
            // slideTransition: 'linear',
            // autoplaySpeed: 8000,
            // smartSpeed: 8000,
            nav : false,
            // animateIn: 'fadeIn',
            // animateOut: 'fadeOut',
            // navText: ['<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use></svg>', '<svg width="7" height="12" aria-hidden="true"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use></svg>'],
            // lazyLoad: true,
            // autoWidth : true,
            responsive: {
                1900: {
                    items: 2,
                    margin : 45,
                }
            }
        });

        // custom nav buttons with the counter
        $('.hmpg__promos_events-cont-navs-next a').click(function(){
            // console.log("next");
            getHomePromosEvents.trigger('next.owl.carousel');
        });
        
        $('.hmpg__promos_events-cont-navs-prev a').click(function(){
            // console.log("prev");
            getHomePromosEvents.trigger('prev.owl.carousel');
        });
        
        
    }    
    
    // =================================
    // Promos & Events Parallax
    // ================================= 
    var parallaxImg = document.querySelectorAll('.hmpg__promos_events-parallax-runnr');

    if(parallaxImg.length){
        new simpleParallax(parallaxImg, {
            delay: .6,
            transition: 'cubic-bezier(0,0,0,2)'
        });
    }
    

    // =================================
    // Outlets Home Promos & Events Parallax
    // ================================= 
    var parallaxImg_outletHome = document.querySelectorAll('.hmpg__promos_events-parallax-execisr');

    if(parallaxImg_outletHome.length){

        // on page load
        if( $(window).width() > 1200 ){
            outletParallaxer(1);
        }

        // on resize
        // $(window).on('resize', function() {
            
        //     if( $(window).width() < 1450 ){
        //         outletParallaxer(0);
        //     }
        //     else{
        //         outletParallaxer(1);
        //     }
        // });
        
    }

    function outletParallaxer(status){
        var outletParallaxerInstance = new simpleParallax(parallaxImg_outletHome, {
            delay: .6,
            transition: 'cubic-bezier(0 ,0 ,0.2 ,1)',
            // orientation: 'down',
            // scale: 1.1,
            // overflow: false,
        });

        // if(status == 0){
        //     outletParallaxerInstance.destroy();
        // }
        // if(status == 1){
        //     outletParallaxerInstance.refresh();
        // }
    }





    // =================================
    // Nice Select
    // =================================
    $('select.niced').niceSelect();


    // =================================
    // Tabbed Gid -> Mobile Dropdown
    // =================================

    let tabbed_mobile_select    = $(".comp__tabbed_elem_tabhead .niced");
    let tabbed_mobile_contents  = $("#nav-tabContent.comp__tabbed_elem_tabcont");
    if(tabbed_mobile_select.length){
        tabbed_mobile_select.on('change', function(){
            let selected_value = $(this).val();
            // console.log(selected_value);

            if( selected_value == 0 ){
                tabbed_mobile_contents.find(".tab-pane").each(function(){
                    $(this).addClass("show active");
                });
            }
            else{
                // let tab_pane_id = tabbed_mobile_contents.find(".tab-pane").attr("id");
    
                tabbed_mobile_contents.find(".tab-pane").each(function(){
                    // let tab_pane_id = $(this).attr("id");
                    $(this).removeClass("show active");
                    if( selected_value == $(this).attr("id").substr(4) ){
                        $(this).addClass("show active");
                    }
                });
            }
            
        });
    }


    // =================================
    // Special Nav Slider
    // =================================    
    let spNavSlidr = $(".viv_spnav_slidr-inr");
    if(spNavSlidr.length){
        let argsspNavSlidr = {
            items: 1,
            loop: true, 
            margin: 20,
            // autoplay: true,
            dots: false,
            navSpeed: 1500,
            // slideTransition: 'linear',
            // autoplaySpeed: 8000,
            // smartSpeed: 8000,
            nav : true,
            navText: ['prev', 'next'],
            lazyLoad: true,
            // autoWidth : true,
            responsive: {
                // 768: {
                //     margin: 2,
                //     items: 2,
                // },
                // 1600: {
                //     items: 3,
                // }
            }
        }
        spNavSlidr.owlCarousel(argsspNavSlidr);
    }



    // =========================================
    // Corp. Gallery page items rounded corners
    // =========================================

    let ig_block_rendered = $("#sbi_images");

    function ig_block_rendered_rounding_above768(){

        ig_block_rendered.each(function(){
            let ig_block_rendered_itemcount = $(this).find('.sbi_item').length;
            // console.log(ig_block_rendered_itemcount);
    
            if(ig_block_rendered_itemcount%2 == 0){
                $(this).addClass("sbi_images_even");
            }
            else{
                $(this).addClass("sbi_images_odd");
            }
    
            // for large devices
    
            if ( $(window).width() > 767 ) {
    
                $(this).removeClass("sbi_images_even");
                $(this).removeClass("sbi_images_odd");
                
                if(ig_block_rendered_itemcount%5 == 0){
                    
                    $(this).addClass("sbi_images_full5");
                }
                else{
                    let remaining = ig_block_rendered_itemcount%5;
                    let first_in_last_row = (ig_block_rendered_itemcount ) - remaining;
                    $(this).addClass("sbi_images_nofull5");
    
                    // $(this).find(".sbi_item:eq(2)").addClass("LOL");
                    $(".sbi_item").eq(first_in_last_row).addClass("sbi_images_nofull5_first_in_last_row");
                }
            }
            else{
                $(this).removeClass("sbi_images_full5");
                $(this).removeClass("sbi_images_nofull5");
            }
    
    
            
    
    
        });


    }

    if(ig_block_rendered.length){
        ig_block_rendered_rounding_above768();
    }

    $(window).on('resize', function() {
        ig_block_rendered_rounding_above768();
    });


    // =========================================
    // Outlet Gallery page items rounded corners
    // =========================================

    let olet_gal_rendered = $(".viv__pg_gallery_grid_items");

    function olet_gal_block_rendered_rounding_above768(){

        olet_gal_rendered.each(function(){
            let olet_gal_rendered_itemcount = $(this).find('.elemgrid__2555_item').length;
            // console.log(ig_block_rendered_itemcount);
    
            if(olet_gal_rendered_itemcount%2 == 0){
                $(this).addClass("gal_items_even");
            }
            else{
                $(this).addClass("gal_items_odd");
            }
    
            // for large devices
    
            if ( $(window).width() > 767 ) {
    
                $(this).removeClass("gal_items_even");
                $(this).removeClass("gal_items_odd");
                
                if(olet_gal_rendered_itemcount%5 == 0){
                    
                    $(this).addClass("gal_items_full5");
                }
                else{
                    let remaining = olet_gal_rendered_itemcount%5;
                    let first_in_last_row = (olet_gal_rendered_itemcount ) - remaining;
                    $(this).addClass("gal_items_nofull5");
    
                    $(".elemgrid__2555_item").eq(first_in_last_row).addClass("gal_items_nofull5_first_in_last_row");
                }
            }
            else{
                $(this).removeClass("gal_items_full5");
                $(this).removeClass("gal_items_nofull5");
            }
    
    
            
    
    
        });


    }

    if(olet_gal_rendered.length){
        olet_gal_block_rendered_rounding_above768();
    }

    $(window).on('resize', function() {
        olet_gal_block_rendered_rounding_above768();
    });

    // =========================================
    // Forms
    // =========================================

    let getForms_fromformbuilder = $("form.dfb-form");
    if(getForms_fromformbuilder.length){
        getForms_fromformbuilder.find(".recapture").parent().addClass("recaptcha_form_group");
        getForms_fromformbuilder.find(".input-group.is_required").parent().addClass("req_fields_form_group");
        getForms_fromformbuilder.find(".fb-submit-row button#validateBtn").addClass("viv__btn_filled");
    }





// ========================================================
// Form Builder formsdata :: Custom Checkboxes
// ========================================================
var fb_forms_chkboxes = $("form.dfb-form .dfb-form-group .response-field-checkboxes .checkbox-inline");

if(fb_forms_chkboxes){
    fb_forms_chkboxes.append('<span class="fb_forms_custom_chkbox"></span>');

    // fb_forms_chkboxes.find("input:checkbox").prop('checked', true);
    
    if( fb_forms_chkboxes.find("input:checkbox").is(":checked") ){
        $('.fb_forms_custom_chkbox').addClass("checked");
    }

    fb_forms_chkboxes.find("input:checkbox").change(function(){
        if($(this).is(":checked")) {
            $('.fb_forms_custom_chkbox').addClass("checked");
        } else {
            $('.fb_forms_custom_chkbox').removeClass("checked");
        }
    });
}





    
    
}); // doc ready



// =================================================
// 91. Owl Slider Trigers 
// =================================================
// Fix owl stagePadding issue
$( window ).on("load", function() {
    $('.owl-carousel').trigger('refresh.owl.carousel');
});
$(window).on("resize", function () {
    $('.owl-carousel').trigger('refresh.owl.carousel');
});
$(document).ready(function() {
    $('.owl-carousel').trigger('refresh.owl.carousel');
});

// =================================================
// 92. Scroll to Top
// =================================================
$(document).ready(function() {
    
    let scrollTopBtn = $(".scroll_to_top");
    
    // Scroll on click
    scrollTopBtn.click(function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    
    // Visibility on scroll position
    $(window).scroll(function (event) {
        let scrollPos = $(window).scrollTop();
        
        if(scrollPos  > 400) { 
            scrollTopBtn.addClass("show"); 
        }
        if(scrollPos  < 400) {
            scrollTopBtn.removeClass("show");
        }
        
    });

    $(".scroll_to_top a").hover(function(){
        $(this).find("span").toggleClass("show");
    });


});


// =================================================
// 93. Running man hover movements
// =================================================
$(document).ready(function() {
    if($('.hmpg__why_vivid')){
        $('.hmpg__why_vivid .hmpg__why_vivid-cont .hmpg__why_vivid-cont-imgsblok').mousemove(function (e) {
            var wx = $(window).width();
            var wy = $(window).height(); 
            var x = e.pageX - this.offsetLeft;
            var y = e.pageY - this.offsetTop; 
            
            var newx = x - wx/2;
            var newy = y - wy/2;        
            /*$('span').text(newx + ", " + newy);*/        
            $(this).find('div, img').each(function(){
                var speed = $(this).attr('data-speed');
                if($(this).attr('data-revert')) speed *= -1;
                TweenMax.to($(this), 1, {x: (1 - newx*speed), y: (1 - newy*speed)});
                
            });        
        }); 
    }
});